import { render, staticRenderFns } from "./SsalesoderIndex.vue?vue&type=template&id=641879bf"
import script from "./SsalesoderIndex.vue?vue&type=script&lang=js"
export * from "./SsalesoderIndex.vue?vue&type=script&lang=js"
import style0 from "./SsalesoderIndex.vue?vue&type=style&index=0&id=641879bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports